import { useState, useEffect } from 'react';

export default function Welcome() {
    const [isAgeVerified, setIsAgeVerified] = useState(false);
    const [isUnder13, setIsUnder13] = useState(false);
    
    // Check for existing verification when component mounts
    useEffect(() => {
        const verification = sessionStorage.getItem('ageVerified');
        if (verification) {
            setIsAgeVerified(true);
            
            // If they previously indicated under 13
            if (verification === 'under13') {
                setIsUnder13(true);
            }
        }
    }, []);
    
    // If the user is not yet age verified, show the age verification overlay
    if (!isAgeVerified) {
        return (
            <div>
                {/* Welcome screen (blurred in background) */}
                <div style={{ filter: 'blur(10px)' }}>
                    <WelcomeContent />
                </div>
                
                {/* Age verification overlay */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(12, 119, 137, 0.8)',
                    backdropFilter: 'blur(10px)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    textAlign: 'center'
                }}>
                    <img alt="Welcome" src="./assets/Welcome-logo.png" style={{ 
                        maxWidth: '60%',
                        marginBottom: '40px'
                    }} />
                    
                    <h2 style={{
                        color: '#FFFFFF',
                        fontSize: '1.6rem',
                        marginBottom: '40px',
                        fontWeight: '400',
                        lineHeight: '1.6rem',
                        textTransform: "uppercase",
                        width:"70%"
                    }}>
                        Are you 13 years or older?
                    </h2>
                    
                    <div style={{ display: 'flex', gap: '20px', marginBottom: '60px' }}>
                        <button 
                            onClick={() => {
                                setIsAgeVerified(true);
                                sessionStorage.setItem('ageVerified', 'yes');
                            }}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '19px 30px 14px',
                                gap: '10px',
                                width: '127px',
                                height: '60px',
                                background: '#FFFFFF',
                                boxShadow: '0px 7px 10px rgba(0, 0, 0, 0.25)',
                                borderRadius: '30px',
                                border: 'none',
                                fontWeight: '400',
                                fontSize: '1.6rem',
                                lineHeight: '1.6rem',
                                textAlign: 'center',
                                textTransform: 'uppercase',
                                color: '#004A7C',
                                cursor: 'pointer'
                            }}
                        >
                            YES
                        </button>
                        
                        <button 
                            onClick={() => {
                                setIsAgeVerified(true);
                                setIsUnder13(true);
                                sessionStorage.setItem('ageVerified', 'under13');
                            }}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '19px 30px 14px',
                                gap: '10px',
                                width: '127px',
                                height: '60px',
                                background: '#FFFFFF',
                                boxShadow: '0px 7px 10px rgba(0, 0, 0, 0.25)',
                                borderRadius: '30px',
                                border: 'none',
                                fontWeight: '400',
                                fontSize: '1.6rem',
                                lineHeight: '1.6rem',
                                textAlign: 'center',
                                textTransform: 'uppercase',
                                color: '#004A7C',
                                cursor: 'pointer'
                            }}
                        >
                            NO
                        </button>
                    </div>
                    
                    <p style={{
                        color: '#FFFFFF',
                        fontSize: '0.95rem',
                        maxWidth: '75%',
                        fontWeight: '400',
                        fontFamily: 'VAG Rundschrift D, Arial, sans-serif',
                    }}>
                        Wondering why we ask this? HARIBO does not target children under 13 in all its marketing activities.
                    </p>
                </div>
            </div>
        );
    }

    // If user is under 13, show the message
    if (isUnder13) {
        return (
            <div>
                {/* Welcome screen (blurred in background) */}
                <div style={{ filter: 'blur(10px)' }}>
                    <WelcomeContent />
                </div>
                
                {/* Age verification overlay */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(12, 119, 137, 0.8)',
                    backdropFilter: 'blur(10px)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    textAlign: 'center'
                }}>
                    <img alt="Welcome" src="./assets/Welcome-logo.png" style={{ 
                        maxWidth: '60%',
                        marginBottom: '40px'
                    }} />
                    
                    <h2 style={{
                        color: '#FFFFFF',
                        fontSize: '1.2rem',
                        marginBottom: '40px',
                        fontWeight: '400',
                        lineHeight: '1.6rem',
                        width:"80%"
                    }}>
                        Unfortunately, you need to be a bit older to visit our website.
                        <br /><br />
                        But we'll be happy to see you again once you've turned 13!
                    </h2>
                    
                </div>
            </div>
        );
    }
    
    // If age is verified, show the normal welcome screen
    return <WelcomeContent />;
}

// Extracted the original welcome content to avoid repetition
function WelcomeContent() {
    return (
        <div style={{margin: 'auto', textAlign: 'center'}}>
        <img alt="" width={'100%'} style={{position: 'relative', top: 0, left: 0}} src="./assets/header-welcome.png" />
        <div style={{background: '#FBB900', color: '#004A7C', padding: '8px', textAlign: 'center', fontSize: '0.9rem', fontWeight: '400', textTransform:"uppercase"}}>
            Explore Europe with Haribo!
        </div>
        <div style={{padding: '20px', height: '60vh',textAlign: 'center', position: 'relative', width: '100%', background: 'linear-gradient(180deg, #FFF4AA 0%, #FFDB00 100%)'}}>
            <div style={{maxWidth: '50%', margin: 0, fontWeight: '400', fontSize: '1.6rem', lineHeight:"1.6rem", color: '#004A7C', textTransform:"uppercase"}}>
                Play your way through the sweetest spots!
            </div>
        </div>
        <div style={{width: '100%'}}>
        
            <img alt="" src="./assets/illustre-1-welcome.png" style={{position: 'absolute', bottom: '25%', zIndex: 2000, objectFit: 'contain', right: 0, width:"50%"}} />
            <img alt="" src="./assets/illustre-2-welcome.png" style={{position: 'absolute', bottom: '25%', zIndex: 0, left: 0, width: "65%"}} />
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 393 773" fill="none" style={{position: 'absolute', bottom: '-6%', left: 0}}>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M-341.732 0H-344V880H736V0H733.732C708.582 274.773 477.434 489.988 196 489.988C-85.4337 489.988 -316.582 274.773 -341.732 0Z" fill="#118A9B"/>
            </svg>
            <div style={{position: 'absolute', bottom: '4%', left: '10%', width: '80%', display: 'flex', flexDirection: 'column', gap: '1rem', zIndex: 3000}}>
                <div
                    onClick={() => { window.location.href = '/form' }}
                    style={{
                    cursor: 'pointer',
                    fontWeight: '400',
                    fontSize: '1.4rem',
                    background: '#FFFFFF',
                    color: '#004A7C',
                    padding: '0.5rem',
                    boxShadow: 'rgba(0, 0, 0, 0.2) 1px 4px 6px 4px',
                    borderRadius: '2.6em',
                    textAlign: 'center'
                    }}
                >
                    LET'S PLAY!
                </div>
                <div
                    onClick={() => { window.location.href = '/ranking' }}
                    style={{
                    cursor: 'pointer',
                    fontWeight: '400',
                    fontSize: '0.9rem',
                    color: 'white',
                    padding: '0.4em',
                    borderRadius: '1.6em',
                    border: 'solid 0.1rem white',
                    textAlign: 'center'
                    }}
                >
                    VIEW RANKING
                </div>
            </div>
        </div>
    </div>
    );
}